import styled from 'styled-components'
import { COLORS } from '~/shared/constants/uiConstants'

export const ProgressAnalyzerStyles = {
  Wrapper: styled.div`
    margin-bottom: 16px;
  `,

  Text: styled.p`
    margin-bottom: 8px;
    font-size: 16px;
    line-height: 22px;
    font-weight: 400;
    color: ${COLORS.BLACK};
    text-align: start;
  `,

  ProgressRow: styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
  `,

  ProgressWrapper: styled.div`
    flex: 1;
    overflow: hidden;
    height: 8px;
    border-radius: 40px;
  `,

  Value: styled.span`
    flex-shrink: 0;
    min-width: 37px;
    font-size: 14px;
    line-height: 18px;
    font-weight: 700;
    color: ${COLORS.BLACK};
  `,
} as const
